import {
  LIST_ORGANIZATIONS_RESPONSE,
  CREATE_ORGANIZATION_RESPONSE,
  UPDATE_ORGANIZATION_RESPONSE,
  ADD_ORGANIZATION_USER_RESPONSE,
  LOGOUT_RESPONSE,
} from '../constants'

const initialState = {}

export default function update(state = initialState, action) {
  switch (action.type) {
    case LIST_ORGANIZATIONS_RESPONSE: {
      const s = { ...state }
      const organizations = action.organizations || []
      organizations.forEach((o) => {
        s[o.id] = {
          ...o,
          isLoading: false,
        }
      })
      return s
    }

    case CREATE_ORGANIZATION_RESPONSE:
    case UPDATE_ORGANIZATION_RESPONSE:
    case ADD_ORGANIZATION_USER_RESPONSE: {
      return {
        ...state,
        [action.organization.id]: {
          ...action.organization,
          isLoading: false,
        },
      }
    }

    case LOGOUT_RESPONSE:
      return initialState

    default:
      return state
  }
}
